import { render, staticRenderFns } from "./DeleteRoomLockModal.vue?vue&type=template&id=52d33393&"
import script from "./DeleteRoomLockModal.vue?vue&type=script&lang=js&"
export * from "./DeleteRoomLockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports